export const GOOGLE_MAPS_CONFIG = {
  id: 'google-map-script',
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  libraries: ['places', 'drawing'], // Include all libraries needed across the app
  version: 'weekly',
  language: 'en',
  region: 'US'
};

// Map container style used across components
export const mapContainerStyle = {
  width: '100%',
  height: '100%',
};